interface IEnkPageContainerProps {
  children: React.ReactNode
}

export default function EnkPageContainer(props: IEnkPageContainerProps) {
  const { children } = props
  return <div className="h-full py-2 px-4 sm:px-6 lg:px-8">{children}</div>
}
